/* eslint-disable max-len */
import PropTypes from 'prop-types'

import { RoadTypes } from '../../models/common/road-types-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'

/**
 * @typedef {Object} SpeedingEvent
 *
 * @property {number}               [averageSpeed]              - The average speed of the object during the speeding event (in kph).
 * @property {number}               [distance]                  - The distance the object covered during the speeding event (in meters).
 * @property {Id}                   [driverId]                  - The ID of the driver.
 * @property {Position}             [endPosition]               - The geo position of the endpoint of the speeding event (decimal degree).
 * @property {ISO8601}              [endTime]                   - The end date of the speeding event (ISO8601).
 * @property {bool}                 [inCity]                    - The location description (in city = true / countryside = false).
 * @property {number}               [maxSpeed]                  - The top speed of the object during the speeding event (in kph).
 * @property {number}               [minSpeed]                  - The minimum speed of the object during the speeding event (in kph).
 * @property {Id}                   [objectId]                  - The ID of the object.
 * @property {number}               [roadSpeedLimit]            - The road speed limit at the position of the object (in kph).
 * @property {roadType}             [roadType]                  - The type of road the speeding event happened on.
 * @property {Id}                   [speedingEventId]           - The ID of the speeding event.
 * @property {Position}             [startPosition]             - The geo position of the starting point of the speeding event (decimal degree).
 * @property {ISO8601}              [startTime]                 - The start date of the speeding event (ISO8601).
 * @property {number}               [vehicleSpeedLimit]         - The vehicle speed limit at the position of the object (in kph).
 * @property {LocationDescription}  [startLocationDescription]  - The location description of the starting point of the speeding event.
 * @property {LocationDescription}  [endLocationDescription]    - The location description of the endpoint of the speeding event.
 */
export const speedingEventPropType = PropTypes.shape({
    averageSpeed: PropTypes.number,
    distance: PropTypes.number,
    driverId: idPropType,
    endLocationDescription: locationDescriptionPropType,
    endPosition: positionPropType,
    endTime: iso8601PropType,
    inCity: PropTypes.bool,
    maxSpeed: PropTypes.number,
    minSpeed: PropTypes.number,
    objectId: idPropType,
    roadSpeedLimit: PropTypes.number,
    roadType: PropTypes.oneOf(Object.values(RoadTypes)),
    speedingEventId: idPropType,
    startLocationDescription: locationDescriptionPropType,
    startPosition: positionPropType,
    startTime: iso8601PropType,
    vehicleSpeedLimit: PropTypes.number
})
